import React from 'react'
import Home from './Home'
import About from './About'
import GlobalFootprint from './GlobalFootprint'
import Sectors from './Sectors'
import Velocity from './Velocity'
import WhoItsFor from './WhoItsFor'
import Pathways from './Pathways'
import VelocityDeliveryCycle from './VelocityDeliveryCycle'
import WhyChoose5Helms from './WhyChoose5Helms'
import WhatSetsUsApart from './WhatSetsUsApart'
import Testimonials from './Testimonials'
import GetInTouch from './GetInTouch'
import Footer from './Footer'
 

const App = () => {
  return (
    <div>
      <Home />
       
      <About />
      <GlobalFootprint />
      <Sectors /> 
      <Velocity />
      <WhoItsFor />
      <Pathways />
      <VelocityDeliveryCycle />
      <WhyChoose5Helms />
      <WhatSetsUsApart />
      <Testimonials />
      <GetInTouch />
      <Footer />
      
    </div>
  )
}

export default App
